module.exports = __webpack_public_path__ + "static/media/gerrit-vermeulen.28917df7.jpg";